<template>
    <transition name="fade">
        <div v-show="showWeAppInOpen" class="miniAppBottom" @click="openWeapp">
            <div class="miniAppBottom_openbtn">
                <div class="openbtnline1">进入小程序</div>
                <div class="openbtnline2">查看更多房源</div>
            </div>
            <img class="openljicon" src="https://pages.anjukestatic.com/fe/esf/img/001acca2/icon.png" />
        </div>
    </transition>
</template>

<script>
export default {
    name: 'OpenInWeapp',
    props: {
        showWeAppInOpen: {
            type: Boolean,
            default: false
        },
        action: {
            type: String,
            default: ''
        },
        query: {
            type: Object,
            default: () => ({})
        }
    },
    methods: {
        openWeapp() {
            // 发送统计
            if (this.action) {
                this.$soj && this.$soj.trackEvent(this.action);
            }
            // 跳转小程序
            const appid = 'wx099e0647f9a4717d';
            const path = 'page/tabbar/pages/home/home';
            let url = `weixin://dl/business/?appid=${appid}&path=${path}`;
            // 添加 query 参数（如果有）
                const queryStr = window.location.search.replace('?', '');
                url += `&query=${encodeURIComponent(queryStr)}`;
            window.location.href = url;
        }
    }
};
</script>

<style lang="scss" scoped>
.open-weapp-btn {
    display: block;
    position: fixed;
    left: 50%;
    bottom: 21px;
    transform: translateX(-50%);
    width: 115px;
    height: 36px;
    font-size: 16px;
    line-height: 36px;
    text-align: center;
    color: #fff;
    background-image: linear-gradient(-269deg, #07c160 0%, #10b981 100%);
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
    border-radius: 100px;
    z-index: 9999;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}
.miniAppBottom {
     position: fixed;
        bottom: 30px;
        left: calc(50% - 76px);
        z-index: 10000;
        display: flex;
        width: 104px;
        height: 50px;
        background-color: rgba(35, 201, 147, 1);
        border-radius: 25px;
        box-shadow: 0px 2px 8px 0px rgba(71, 75, 78, 0.14);
        align-items: center;
        padding: 0 24px;
        &_openbtn {
            .openbtnline1 {
                font-family: PingFangSC-Medium;
                font-size: 14px;
                font-weight: 500;
                color: rgba(255, 255, 255, 1);
                margin-bottom: 4px;
            }
            .openbtnline2 {
                font-family: PingFangSC-Regular;
                font-size: 12px;
                color: rgba(255, 255, 255, 1);
            }
        }

    .openljicon {
        width: 22px;
        height: 22px;
        margin-left: auto;
    }
}
</style>
